import PageHeader from "../../components/ui/PageHeader";
import { useTranslation } from "react-i18next";
import { Box, Button, TextField, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useAppDispatch, useAppSelector } from "../../redux";
import { AppDispatch } from "../../redux/store";
import { getBreefInviteTracking } from "../../service/BreefInviteService";
import { useNavigate } from "react-router-dom";
import BreefTrackingTable from "./BreefTrackingTable";

/** The invitations per breef with the filters - shown on the Queues page (tab "Invitationer") */
export function BreefTrackingSection() {
  const [t] = useTranslation("global");
  const isMobile = useMediaQuery("(max-width:600px)");
  const dispatch: AppDispatch = useAppDispatch();
  const data = useAppSelector((state) => state.breefInvites);
  const navigate = useNavigate();

  const [tenantEmail, setTenantEmail] = useState("");
  const [tenantPhone, setTenantPhone] = useState("");
  const [appliedFilters, setAppliedFilters] = useState({ tenantEmail: "", tenantPhone: "" });

  const fetchTracking = async () => {
    await getBreefInviteTracking(
      dispatch,
      isMobile,
      navigate,
      appliedFilters.tenantEmail,
      appliedFilters.tenantPhone
    );
  };

  useEffect(() => {
    fetchTracking();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliedFilters]);

  const handleApplyFilters = () => {
    setAppliedFilters({ tenantEmail, tenantPhone });
  };

  const handleClearFilters = () => {
    setTenantEmail("");
    setTenantPhone("");
    setAppliedFilters({ tenantEmail: "", tenantPhone: "" });
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: 2,
          flexWrap: "wrap",
          margin: "1% auto",
          width: "100%",
        }}
      >
        <TextField
          label={t("fields.tenantEmail")}
          size="small"
          value={tenantEmail}
          onChange={(e) => setTenantEmail(e.target.value)}
        />
        <TextField
          label={t("fields.tenantPhone")}
          size="small"
          value={tenantPhone}
          onChange={(e) => setTenantPhone(e.target.value)}
        />
        <Button variant="contained" onClick={handleApplyFilters}>
          {t("tracking.filter")}
        </Button>
        <Button variant="outlined" onClick={handleClearFilters}>
          {t("tracking.clear")}
        </Button>
      </Box>
      <Box>
        <BreefTrackingTable results={data.trackingData.results} />
      </Box>
    </>
  );
}

/** The old page address (/breef-tracking) still works; the section lives on the Queues page now */
export default function BreefTrackingList() {
  const [t] = useTranslation("global");
  return (
    <Layout>
      <PageHeader title={t("tracking.title")} description={t("tracking.intro")} />
      <BreefTrackingSection />
    </Layout>
  );
}
